
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as jsU0GZdPGYoWv9Z9OyJwpUDOIF1_452xus_KoRc9l1qakakMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/js.vue?macro=true";
import { default as fptfP6HzPcR4ilpUZ05Rtfe4hW2i5UZy2_45ZZpqt9E_97noMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/fpt.vue?macro=true";
import { default as indexItLb_RXQ11799dkFPXyql8RkMtWMxok1rKaZq025RfUMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/index.vue?macro=true";
import { default as dang_45kypExhPZrmYV4gkP0_45pJPm0p1IRTShijOJGzUB_45hzWMx8Meta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/dang-ky.vue?macro=true";
import { default as loadingkq0zV83WSd7aOwEigqBr32yQGbiq_45R_45CQk4hrk31K5AMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/loading.vue?macro=true";
import { default as tai_45khoanKJP9Kt077236puspK7jWAKOkv5iwwQg_RAPtJGAFyp8Meta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/tai-khoan.vue?macro=true";
import { default as indexnx332gsMw_5ko_9ElI30KXQe9pAtYyFuh94ZBTNppzsMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/index.vue?macro=true";
import { default as _91slug_938dcWEAFNszClfMJxS3idYCX1QmtXdn_45k6wgY1TmdfgwMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/[slug].vue?macro=true";
import { default as createTT96D3gUgohBwUFO5bfPb2n0zMLmEs_AQq0pKm73BF8Meta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/create.vue?macro=true";
import { default as indexjy8EFTWs2pvQpC2n4p0vebQ4_vnimr4goNMXPtgUY20Meta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/khoa-hoc/index.vue?macro=true";
import { default as cancel5fPUlnRauwpBnhJCD_Hrz9FxBU2Y7Ve2Qo7wwy3dUw0Meta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/payment/cancel.vue?macro=true";
import { default as rewardsBfCSUOygooXGjkeb0tQ2k84zcKRE_455fAzBDOmfZXqqAMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/points/rewards.vue?macro=true";
import { default as bookmark66pJ4P_KON4sifZpbUotLJexJghcFllf3lgh_45hKkRuUMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/bookmark.vue?macro=true";
import { default as privacy_45policylhG_e_PeDPzJRcoTIbAP3xwGyCS5J10lj6nyb4bYtTIMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/privacy-policy.vue?macro=true";
import { default as indexuLQS1ybsAraRDUIBQVwOEiGPeZ5vNc8r6qv9gc8pjTMMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/users/me/index.vue?macro=true";
import { default as _91slug_9318ItnzrKz7mSGsV0e_45GRCDvlSidN7h0mpurnhN414moMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/khoa-hoc/[slug].vue?macro=true";
import { default as create9u9iemB_45ZCi0vUc5r3oZB1_455jVFFw4jmRQugQItHRSwMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/khoa-hoc/create.vue?macro=true";
import { default as success47eGUPjlHNFylEkVX0r4pwQsEfT_45SsdDiy7KbPzA5_45EMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/payment/success.vue?macro=true";
import { default as missionsXG6eK2ts_hsSc5lQx9RIgIpg2iLDdpA4acVwIWpkU7AMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/points/missions.vue?macro=true";
import { default as followingvTS4lARd9jRKwEOMpamHuoTCLZzGXvloLAb6OZFGM8QMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/following.vue?macro=true";
import { default as _91username_93mzD1mL3FLbKIX_BuwdTt_GfF5dKhwm7Ombm57lpDFGkMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/users/[username].vue?macro=true";
import { default as _91slug_93CENxyV8tVCHtiDP0FL9nR_45oR_45HHbR3HyRWpidYgYkP4Meta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/edit/[slug].vue?macro=true";
import { default as feedbackIYhc3hMwgPYisrkWS02S5lD6KDaNDmaL7KAmL4gocMQMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/users/me/feedback.vue?macro=true";
import { default as nang_45cap_45tai_45khoan5eLQyeisCd_UZ_457GnTI_456YK8GL_45q2yN8VB8qK3ZzP5kMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/nang-cap-tai-khoan.vue?macro=true";
import { default as indexo2PF2UbNeJoZbuROTW4P6PjZBHwuT6Ze1CTqb_45qvsMUMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/phong-van-pro/index.vue?macro=true";
import { default as _91slug_93D0vxG2dIYuLYZIjXzpsLfmptAr_OzCH5JM9uX6s5L98Meta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/topics/[slug].vue?macro=true";
import { default as _91slug_93LJWafekkETnEnKg3Tv1md2jj3h2tHNTJkqFz3anD23MMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/khoa-hoc/edit/[slug].vue?macro=true";
import { default as doi_45mat_45khaupf4HE5dalvD7zHxdqAlrN5XYLm5AfJlSLWcFsLo2IwEMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/users/me/doi-mat-khau.vue?macro=true";
import { default as _91slug_93WQbIFR_m28CZtKwCTcMUOlH8lebwCqmnrqbnCnYhBLcMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/cau-hoi-phong-van/[slug].vue?macro=true";
import { default as _91slug_93vqK4ibBfhCH0CAopoewNEpPu5uuvWdMPbLJVcLzzb0MMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/khoa-hoc/the-loai/[slug].vue?macro=true";
import { default as _91slug_93HmZqlo9J0sr7YWTLMjuuAIYf9smFrJsxMLZMiuRTpREMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/bai-viet/[category]/[slug].vue?macro=true";
import { default as _91category_93pTlhDmYklON7qSdsw7v7Je7z_u_UY7CVZIXRIBfZMUwMeta } from "/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/phong-van-pro/[topic]/[category].vue?macro=true";
export default [
  {
    name: "js",
    path: "/js",
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/js.vue")
  },
  {
    name: "fpt",
    path: "/fpt",
    meta: fptfP6HzPcR4ilpUZ05Rtfe4hW2i5UZy2_45ZZpqt9E_97noMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/fpt.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexItLb_RXQ11799dkFPXyql8RkMtWMxok1rKaZq025RfUMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/index.vue")
  },
  {
    name: "dang-ky",
    path: "/dang-ky",
    meta: dang_45kypExhPZrmYV4gkP0_45pJPm0p1IRTShijOJGzUB_45hzWMx8Meta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/dang-ky.vue")
  },
  {
    name: "loading",
    path: "/loading",
    meta: loadingkq0zV83WSd7aOwEigqBr32yQGbiq_45R_45CQk4hrk31K5AMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/loading.vue")
  },
  {
    name: "tai-khoan",
    path: "/tai-khoan",
    meta: tai_45khoanKJP9Kt077236puspK7jWAKOkv5iwwQg_RAPtJGAFyp8Meta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/tai-khoan.vue")
  },
  {
    name: "posts",
    path: "/posts",
    meta: indexnx332gsMw_5ko_9ElI30KXQe9pAtYyFuh94ZBTNppzsMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/index.vue")
  },
  {
    name: "posts-slug",
    path: "/posts/:slug()",
    meta: _91slug_938dcWEAFNszClfMJxS3idYCX1QmtXdn_45k6wgY1TmdfgwMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/[slug].vue")
  },
  {
    name: "posts-create",
    path: "/posts/create",
    meta: createTT96D3gUgohBwUFO5bfPb2n0zMLmEs_AQq0pKm73BF8Meta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/create.vue")
  },
  {
    name: "khoa-hoc",
    path: "/khoa-hoc",
    meta: indexjy8EFTWs2pvQpC2n4p0vebQ4_vnimr4goNMXPtgUY20Meta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/khoa-hoc/index.vue")
  },
  {
    name: "payment-cancel",
    path: "/payment/cancel",
    meta: cancel5fPUlnRauwpBnhJCD_Hrz9FxBU2Y7Ve2Qo7wwy3dUw0Meta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/payment/cancel.vue")
  },
  {
    name: "points-rewards",
    path: "/points/rewards",
    meta: rewardsBfCSUOygooXGjkeb0tQ2k84zcKRE_455fAzBDOmfZXqqAMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/points/rewards.vue")
  },
  {
    name: "posts-bookmark",
    path: "/posts/bookmark",
    meta: bookmark66pJ4P_KON4sifZpbUotLJexJghcFllf3lgh_45hKkRuUMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/bookmark.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policylhG_e_PeDPzJRcoTIbAP3xwGyCS5J10lj6nyb4bYtTIMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/privacy-policy.vue")
  },
  {
    name: "users-me",
    path: "/users/me",
    meta: indexuLQS1ybsAraRDUIBQVwOEiGPeZ5vNc8r6qv9gc8pjTMMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/users/me/index.vue")
  },
  {
    name: "khoa-hoc-slug",
    path: "/khoa-hoc/:slug()",
    meta: _91slug_9318ItnzrKz7mSGsV0e_45GRCDvlSidN7h0mpurnhN414moMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/khoa-hoc/[slug].vue")
  },
  {
    name: "khoa-hoc-create",
    path: "/khoa-hoc/create",
    meta: create9u9iemB_45ZCi0vUc5r3oZB1_455jVFFw4jmRQugQItHRSwMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/khoa-hoc/create.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    meta: success47eGUPjlHNFylEkVX0r4pwQsEfT_45SsdDiy7KbPzA5_45EMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/payment/success.vue")
  },
  {
    name: "points-missions",
    path: "/points/missions",
    meta: missionsXG6eK2ts_hsSc5lQx9RIgIpg2iLDdpA4acVwIWpkU7AMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/points/missions.vue")
  },
  {
    name: "posts-following",
    path: "/posts/following",
    meta: followingvTS4lARd9jRKwEOMpamHuoTCLZzGXvloLAb6OZFGM8QMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/following.vue")
  },
  {
    name: "users-username",
    path: "/users/:username()",
    meta: _91username_93mzD1mL3FLbKIX_BuwdTt_GfF5dKhwm7Ombm57lpDFGkMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/users/[username].vue")
  },
  {
    name: "posts-edit-slug",
    path: "/posts/edit/:slug()",
    meta: _91slug_93CENxyV8tVCHtiDP0FL9nR_45oR_45HHbR3HyRWpidYgYkP4Meta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/edit/[slug].vue")
  },
  {
    name: "users-me-feedback",
    path: "/users/me/feedback",
    meta: feedbackIYhc3hMwgPYisrkWS02S5lD6KDaNDmaL7KAmL4gocMQMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/users/me/feedback.vue")
  },
  {
    name: "nang-cap-tai-khoan",
    path: "/nang-cap-tai-khoan",
    meta: nang_45cap_45tai_45khoan5eLQyeisCd_UZ_457GnTI_456YK8GL_45q2yN8VB8qK3ZzP5kMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/nang-cap-tai-khoan.vue")
  },
  {
    name: "phong-van-pro",
    path: "/phong-van-pro",
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/phong-van-pro/index.vue")
  },
  {
    name: "posts-topics-slug",
    path: "/posts/topics/:slug()",
    meta: _91slug_93D0vxG2dIYuLYZIjXzpsLfmptAr_OzCH5JM9uX6s5L98Meta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/posts/topics/[slug].vue")
  },
  {
    name: "khoa-hoc-edit-slug",
    path: "/khoa-hoc/edit/:slug()",
    meta: _91slug_93LJWafekkETnEnKg3Tv1md2jj3h2tHNTJkqFz3anD23MMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/khoa-hoc/edit/[slug].vue")
  },
  {
    name: "users-me-doi-mat-khau",
    path: "/users/me/doi-mat-khau",
    meta: doi_45mat_45khaupf4HE5dalvD7zHxdqAlrN5XYLm5AfJlSLWcFsLo2IwEMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/users/me/doi-mat-khau.vue")
  },
  {
    name: "cau-hoi-phong-van-slug",
    path: "/cau-hoi-phong-van/:slug()",
    meta: _91slug_93WQbIFR_m28CZtKwCTcMUOlH8lebwCqmnrqbnCnYhBLcMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/cau-hoi-phong-van/[slug].vue")
  },
  {
    name: "khoa-hoc-the-loai-slug",
    path: "/khoa-hoc/the-loai/:slug()",
    meta: _91slug_93vqK4ibBfhCH0CAopoewNEpPu5uuvWdMPbLJVcLzzb0MMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/khoa-hoc/the-loai/[slug].vue")
  },
  {
    name: "bai-viet-category-slug",
    path: "/bai-viet/:category()/:slug()",
    meta: _91slug_93HmZqlo9J0sr7YWTLMjuuAIYf9smFrJsxMLZMiuRTpREMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/bai-viet/[category]/[slug].vue")
  },
  {
    name: "phong-van-pro-topic-category",
    path: "/phong-van-pro/:topic()/:category()",
    meta: _91category_93pTlhDmYklON7qSdsw7v7Je7z_u_UY7CVZIXRIBfZMUwMeta || {},
    component: () => import("/Users/thaycacac/Documents/company/techmely/kungfutech/kungfutech-fe-v2/pages/phong-van-pro/[topic]/[category].vue")
  }
]